import React from 'react';

export default () => <div class="loading-container-global"><p>Loading...</p></div>;